module.exports = __webpack_public_path__ + "static/media/image11.f56585d0.png";